<p-dialog
  [modal]="true"
  [(visible)]="visible"
  (onHide)="closeModal()"
  class="mx-10"
>
  @if (displaySelectPrestation) {
    <app-prestation-type-selector />
  } @else if (displayAddTransport) {
    <app-transport-modal />
  } @else if (displayAddAccommodation) {
    <app-accommodation-modal />
  } @else if (displayAddActivity) {
    <app-activity-modal />
  } @else if (displayAddMeal) {
    <app-meal-modal />
  }
</p-dialog>
